import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=3af11256"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports